import React, { InputHTMLAttributes, ReactNode, useState } from 'react'
import { FieldValues, Path, UseFormRegister, Validate } from 'react-hook-form'
import { Error } from '../../../../icons'
import { commonShadowStyles } from './InputStyles'

// TODO: This needs to be looked at later on as it seems to be a direct copy from code elsewhere in the project, by the dev we got rid of (so who knows what he was doing). This is probably 90% duplicated code. But also, it is not a good idea to have a component that is so specific to a form library. It should be more generic and reusable. Or at least, it should be in a shared place so all forms can use it. One thing I did improve is to make this accept generic types, in preparation for reviewing and moving to shared components.

interface InputFieldProps<T extends FieldValues>
  extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  className?: string
  errors?: any
  setError?: any
  errorMessage?: string
  register?: UseFormRegister<T>
  regexPattern?: RegExp
  required?: boolean
  validate?: () =>
    | Validate<any, FieldValues>
    | Record<string, Validate<any, FieldValues>>
  password?: string
  repeatPassword?: string
  biggerInput?: boolean
  readOnly?: boolean
  onClick?: () => void
  icon?: ReactNode
  labelSize?: string
  innerClassName?: string
  id: Path<T>
}

export const InputField = <T extends FieldValues>({
  register,
  required,
  validate,
  regexPattern,
  label,
  className,
  errors,
  setError,
  errorMessage,
  innerClassName,
  labelSize,
  ...props
}: InputFieldProps<T>) => {
  const [isTyping, setIsTyping] = useState(false)

  return (
    <div
      className={`w-full flex flex-col justify-self-start item-center ${props.readOnly && 'cursor-not-allowed'
        }`}
    >
      <div
        className={`relative ${className}`}
        onClick={props.onClick && props.onClick}
      >
        {props.icon && (
          <div className='absolute inset-y-0 right-4 flex items-center'>
            {props.icon}
          </div>
        )}
        <input
          {...(register
            ? register(props.id, {
              required: required,
              pattern: regexPattern,
            })
            : {})}
          type='text'
          onChange={(e) => {
            register?.(props.id)?.onChange?.(e)
            setIsTyping(true)
            props.onChange?.(e)
          }}
          onBlur={(e) => {
            register?.(props.id)?.onBlur?.(e)
            setIsTyping(false)
            props.onBlur?.(e)
          }}
          className={`${innerClassName} ${props.disabled && '!bg-[#F4F4F4] !text-[#A0ABBE]'
            } h-full peer block w-full appearance-none rounded-lg bg-white p-[4px_10px] pt-[16px] ${props.value ? 'text-[#00323D]' : 'text-[#818285]'} placeholder-transparent text-[14px] focus:outline-none focus:border-[#37A2BA] ${errors?.[props.id] ? 'border-[#DE3333]' : 'border-[#F4F4F4]'
            } ${props.readOnly && 'cursor-pointer'} ${isTyping && 'text-[#00323D]'
            }`}
          style={commonShadowStyles}
          aria-labelledby={`${props.id}-label`}
          aria-invalid={errors?.[props.id] ? 'true' : 'false'}
          readOnly={props.readOnly}
          disabled={props.disabled}
          {...props}
        />
        <label
          htmlFor={props.id}
          id={`${props.id}-label`}
          className={`text-xs md:text-[12px] absolute text-[#37A2BA] left-[11px] max-w-[calc(100%-20px)] whitespace-nowrap overflow-hidden text-ellipsis top-[13px] transform -translate-y-1/2 transition-all duration-200 ease-in-out
              peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-base peer-placeholder-shown:text-[#818285] ${props.disabled && '!text-[#A0ABBE]'
            }
              peer-focus:top-[10px] peer-focus:text-[12px] ${errors?.[props.id]
              ? '!peer-focus:text-[#DE3333] text-[16px] !peer-placeholder-shown:text-[#DE3333] !text-[#DE3333]'
              : 'peer-focus:text-teal-600'
            }`}
        >
          {!props.readOnly && label}
        </label>
      </div>
      {errors?.[props.id]?.type && (
        <div className='flex justify-self-start items-center pt-1 gap-y-4'>
          <Error width='18px' height='18px' />
          <span className='text-sm text-[#DE3333] font-normal'>
            {errorMessage}
          </span>
        </div>
      )}
    </div>
  )
}
